
(() => {
  const PROP = "_promo_gift";
  const KEY = "sa_promo_code";      
  const MSG_KEY = "sa_promo_msg";   
  const MSG_TTL = 10 * 60 * 1000;

  const SYNC = "promo-gift-sync";

  const S = (k, d) => (window.themeStrings && window.themeStrings[k]) || d;
  const norm = (v) => String(v || "").trim().toLowerCase();
  const same = (a, b) => norm(a) === norm(b);

  const live = new Set();
  let rules = [];
  let lastMsg = readMsg();
  let lastInput = null;
  let lock = 0;           
  let checking = null;    
  let subscribed = false;
  let booted = false;

  let expanded = false;

  function readMsg() {
    try {
      const m = JSON.parse(sessionStorage.getItem(MSG_KEY) || "null");
      return m && Date.now() - m.at < MSG_TTL ? m : null;
    } catch (e) {
      return null;
    }
  }

  function say(text, ok = false, persist = false) {
    lastMsg = text ? { text, ok, at: Date.now() } : null;
    try {
      if (lastMsg && persist) sessionStorage.setItem(MSG_KEY, JSON.stringify(lastMsg));
      else sessionStorage.removeItem(MSG_KEY);
    } catch (e) {

    }
    live.forEach((el) => el.render());
  }

  const giftLines = (cart) =>
    (cart.items || [])
      .map((it, i) => ({ it, line: i + 1 }))
      .filter((x) => x.it.properties && x.it.properties[PROP]);

  const paidSubtotal = (cart) =>
    (cart.items || [])
      .filter((it) => !(it.properties && it.properties[PROP]))
      .reduce((n, it) => n + it.final_line_price, 0);

  const codeEntry = (cart, code) => (cart.discount_codes || []).find((d) => same(d.code, code));

  const hasForeignDiscount = (cart, code) =>
    (cart.cart_level_discount_applications || []).some((d) => !same(d.title, code)) ||
    (cart.items || []).some((i) => (i.line_level_discount_allocations || []).length > 0);

  function notApplicableMsg(cart, code) {
    if (!cart || !hasForeignDiscount(cart, code)) return S("promoUnknown", "Промокод не знайдено");
    const form = document.querySelector("[data-promo-form][data-discountalert]");
    return (
      (form && form.dataset.discountalert) ||
      S("promoNotCombinable", "Промокод не діє разом зі знижкою, яка вже застосована до товарів у кошику")
    );
  }

  const codesWithout = (cart, drop) =>
    (cart.discount_codes || []).map((d) => d.code).filter((c) => !drop.some((x) => same(x, c)));

  const SF_URL = "/api/2025-07/graphql.json";
  const GC_KEY = "sa_giftcards";   

  const GC_FIELDS = "appliedGiftCards { id lastCharacters amountUsed { amount } balance { amount } }";
  const escHtml = (v) =>
    String(v).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  const moneyOf = (amount) =>
    window.ThemeUtils ? window.ThemeUtils.formatMoney(Math.round(Number(amount || 0) * 100)) : String(amount || 0);

  async function sf(query, variables) {
    const res = await fetch(SF_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ query, variables }),
    });
    const j = await res.json();
    if (j.errors) throw new Error(j.errors.map((e) => e.message).join("; "));
    return j.data;
  }
  async function cartGid() {
    const c = await window.CartAPI.get().catch(() => null);
    return c && c.token ? `gid://shopify/Cart/${c.token}` : null;
  }
  function flagGiftCards(on) {
    try {
      if (on) sessionStorage.setItem(GC_KEY, "1");
      else sessionStorage.removeItem(GC_KEY);
    } catch (e) {

    }
  }
  const giftCardsFlagged = () => {
    try {
      return sessionStorage.getItem(GC_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  function giftCardStatus(g) {
    const used = Math.round(Number((g.amountUsed && g.amountUsed.amount) || 0) * 100);
    const left = Math.round(Number((g.balance && g.balance.amount) || 0) * 100);
    return S("giftcardStatus", "На сертифікаті {{ total }}, після оплати залишиться {{ left }}")
      .replace("{{ total }}", moneyOf((used + left) / 100))
      .replace("{{ left }}", moneyOf(left / 100));
  }

  function renderGiftCards(cards) {
    const label = S("giftcardLabel", "Сертифікат");
    const rm = S("giftcardRemove", "Скасувати сертифікат");
    document.querySelectorAll("[data-cart-giftcards]").forEach((box) => {
      const cls = box.dataset.layout === "page" ? "cart-page__discount" : "discount";
      box.innerHTML = cards
        .map(
          (g) =>
            `<div class="cart-giftcard-item">` +
            `<div class="${cls} cart-discount cart-giftcard"><span class="label">${escHtml(label)} •••• ` +
            `${escHtml(String(g.lastCharacters || "").toUpperCase())}` +
            `<button type="button" class="cart-discount__remove" data-giftcard-remove="${escHtml(g.id)}" ` +
            `aria-label="${escHtml(rm)}" title="${escHtml(rm)}">&times;</button></span>` +
            `<span class="value">&minus;${escHtml(moneyOf(g.amountUsed && g.amountUsed.amount))}</span></div>` +
            `<div class="cart-giftcard__status">${escHtml(giftCardStatus(g))}</div>` +
            `</div>`
        )
        .join("");
    });

    const used = cards.reduce((n, g) => n + Math.round(Number(g.amountUsed?.amount || 0) * 100), 0);
    if (!window.ThemeUtils) return;
    document.querySelectorAll("[data-cart-total]").forEach((el) => {
      el.textContent = window.ThemeUtils.formatMoney(Math.max(0, (Number(el.dataset.cartTotal) || 0) - used));
    });
  }

  async function refreshGiftCards() {
    if (!giftCardsFlagged()) return;
    try {
      const id = await cartGid();
      if (!id) return;
      const d = await sf(`query($id: ID!) { cart(id: $id) { ${GC_FIELDS} } }`, { id });
      const cards = (d && d.cart && d.cart.appliedGiftCards) || [];
      if (!cards.length) flagGiftCards(false);
      renderGiftCards(cards);
    } catch (e) {
      console.warn("[promo-gift] сертифікати", e);
    }
  }

  async function applyGiftCard(code) {
    const id = await cartGid();
    if (!id) return null;
    const d = await sf(
      `mutation($id: ID!, $c: [String!]!) { cartGiftCardCodesAdd(cartId: $id, giftCardCodes: $c) { cart { ${GC_FIELDS} } userErrors { message } } }`,
      { id, c: [code] }
    );
    const cards = (d && d.cartGiftCardCodesAdd && d.cartGiftCardCodesAdd.cart && d.cartGiftCardCodesAdd.cart.appliedGiftCards) || [];
    const tail = String(code).replace(/[\s-]/g, "").slice(-4).toLowerCase();
    if (!cards.some((g) => String(g.lastCharacters || "").toLowerCase() === tail)) return null;
    flagGiftCards(true);
    renderGiftCards(cards);
    return cards;
  }

  async function removeGiftCard(giftCardId) {
    const id = await cartGid();
    if (!id) return;
    const d = await sf(
      `mutation($id: ID!, $g: [ID!]!) { cartGiftCardCodesRemove(cartId: $id, appliedGiftCardIds: $g) { cart { ${GC_FIELDS} } userErrors { message } } }`,
      { id, g: [giftCardId] }
    );
    const cards = (d && d.cartGiftCardCodesRemove && d.cartGiftCardCodesRemove.cart && d.cartGiftCardCodesRemove.cart.appliedGiftCards) || [];
    if (!cards.length) flagGiftCards(false);
    renderGiftCards(cards);
  }

  function findRule(code) {
    const now = Date.now();
    return rules.find((r) => {
      if (!same(r.code, code)) return false;
      if (r.active === false) return false;
      if (r.starts_at && new Date(r.starts_at).getTime() > now) return false;
      if (r.ends_at && new Date(r.ends_at).getTime() < now) return false;
      return true;
    });
  }

  function giftIsFree(cart, code) {
    const entry = codeEntry(cart, code);
    const lines = giftLines(cart).filter((x) => same(x.it.properties[PROP], code));
    return Boolean(
      entry && entry.applicable !== false && lines.length && lines.every((x) => x.it.final_line_price === 0)
    );
  }

  function dropGift(cart, code) {
    const gifts = giftLines(cart).filter((x) => !code || same(x.it.properties[PROP], code));
    const updates = {};
    gifts.forEach((x) => {
      updates[x.it.key] = 0;
    });
    const drop = code ? [code] : gifts.map((x) => x.it.properties[PROP]);
    return window.CartAPI.update(
      { updates, discount: codesWithout(cart, drop).join(",") },
      { source: SYNC }
    );
  }

  function setCode(cart, code, source, silent = false) {
    return window.CartAPI.update(
      { discount: [...codesWithout(cart, [code]), code].join(",") },
      { source, silent }
    );
  }

  function revalidate(cartHint, boot = false) {
    if (lock) return Promise.resolve();
    if (checking) return checking;
    checking = (async () => {
      let cart = cartHint && Array.isArray(cartHint.items) ? cartHint : await window.CartAPI.get();
      const codes = [...new Set(giftLines(cart).map((x) => x.it.properties[PROP]))];
      for (const code of codes) {
        const rule = findRule(code);
        const min = rule ? Number(rule.min_subtotal) || 0 : 0;
        let why = null;

        if (!rule || (min && paidSubtotal(cart) < min * 100)) {
          why = S("promoRemoved", "Подарунок знято: умову більше не виконано");
        } else {

          const mine = giftLines(cart).filter((x) => same(x.it.properties[PROP], code));
          const hasFree = mine.some((x) => x.it.final_line_price === 0);
          const updates = {};
          mine.forEach((x) => {
            if (hasFree && x.it.final_line_price !== 0) updates[x.it.key] = 0;
            else if (x.it.quantity > 1) updates[x.it.key] = 1;
          });
          if (Object.keys(updates).length) {
            cart = await window.CartAPI.update({ updates }, { source: SYNC });
          }

          if (!codeEntry(cart, code)) cart = await setCode(cart, code, SYNC);
          if (!giftIsFree(cart, code)) {
            why = boot
              ? S("promoGiftRevoked", "Подарунок прибрано: промокод недоступний для цього замовлення.")
              : S("promoRemoved", "Подарунок знято: умову більше не виконано");
          }
        }

        if (why) {
          cart = await dropGift(cart, code);
          try {
            if (same(localStorage.getItem(KEY), code)) localStorage.removeItem(KEY);
          } catch (e) {

          }
          say(why, false, true);
        }
      }
    })()
      .catch((e) => console.error("[promo-gift] revalidate", e))
      .finally(() => {
        checking = null;
      });
    return checking;
  }

  async function applyGift(rule) {
    lock += 1;
    try {
      let cart = await window.CartAPI.get();
      const min = Number(rule.min_subtotal) || 0;
      if (min && paidSubtotal(cart) < min * 100) {
        say(
          S("promoMinSubtotal", "Замовлення від {{ amount }}").replace(
            "{{ amount }}",
            window.ThemeUtils.formatMoney(min * 100)
          )
        );
        return;
      }

      const label = S("promoGiftLine", "Подарунок за промокодом");
      const items = (rule.gift_products || [])
        .filter((v) => v.variant_id)
        .map((v) => ({ id: v.variant_id, quantity: 1, properties: { [PROP]: rule.code, [label]: rule.code } }));
      if (!items.length) {
        say(S("promoNoStock", "Подарунок наразі недоступний"));
        return;
      }

      if (giftLines(cart).length) cart = await dropGift(cart, null);

      try {
        await window.CartAPI.add(items, { source: SYNC, silent: true });
      } catch (e) {
        say(S("promoNoStock", "Подарунок наразі недоступний"));
        return;
      }
      cart = await setCode(await window.CartAPI.get(), rule.code, SYNC, true);

      if (giftIsFree(cart, rule.code)) {
        try {
          localStorage.setItem(KEY, rule.code);
        } catch (e) {

        }
        say(S("promoApplied", "Подарунок додано"), true);

        await window.CartAPI.update({}, { source: "promo-gift" }).catch(() =>
          window.PubSub.publish(window.EVENTS.cartUpdate, { cart, source: "promo-gift" })
        );
        return;
      }

      console.warn(
        `[promo-gift] Shopify не підтвердив код «${rule.code}»: або його вже використано / вичерпано, ` +
          "або для правила немає рідної знижки з цим кодом (migrate/sync_promo_gifts.py).",
        codeEntry(cart, rule.code)
      );
      await dropGift(cart, rule.code);
      say(S("promoNotAvailable", "Промокод не застосовано: його вже використано або умови не виконано."));
    } finally {
      lock -= 1;
    }
  }

  async function applyCode(code) {
    let cart = await window.CartAPI.get().catch(() => null);
    try {
      if (!cart) throw new Error("no cart");
      cart = await setCode(cart, code, SYNC);
    } catch (e) {
      say(S("promoUnknown", "Промокод не знайдено"));
      return;
    }
    const entry = codeEntry(cart, code);
    if (!entry || entry.applicable === false) {
      const why = notApplicableMsg(cart, code);
      if (entry) {
        await window.CartAPI.update({ discount: codesWithout(cart, [code]).join(",") }, { source: SYNC }).catch(
          () => {}
        );
      }

      const gc = await applyGiftCard(code).catch((e) => {
        console.warn("[promo-gift] сертифікат", e);
        return null;
      });
      if (gc) {
        say(S("giftcardApplied", "Сертифікат застосовано."), true);
        return;
      }
      say(why);
      return;
    }

    say(S("promoOkApplied", S("promoApplied", "Промокод застосовано")), true);
    window.PubSub.publish(window.EVENTS.cartUpdate, { cart, source: "promo-code" });
  }

  function ensureSubscribed() {
    if (subscribed || !window.PubSub || !window.EVENTS) return;
    subscribed = true;

    window.PubSub.subscribe(window.EVENTS.cartUpdate, (data) => {

      refreshGiftCards();

      if (data && (data.source === SYNC || data.source === "promo-gift")) return;
      const cart = data && data.cart;
      if (!cart) {
        let saved = null;
        try {
          saved = localStorage.getItem(KEY);
        } catch (e) {

        }
        if (!saved) return;
      }
      revalidate(cart);
    });
  }

  class PromoGift extends HTMLElement {
    connectedCallback() {
      try {
        rules = JSON.parse(this.querySelector("[data-promo-rules]")?.textContent || "[]");
      } catch (e) {
        console.error("[promo-gift] bad rules", e);
      }
      this.input = this.querySelector("[data-promo-input]");
      this.msg = this.querySelector("[data-promo-msg]");
      live.add(this);

      this.querySelector("[data-promo-clear]")?.addEventListener("click", () => {
        if (this.input) this.input.value = "";
        lastInput = "";
        say("");
      });

      this.querySelector("[data-promo-toggle]")?.addEventListener("click", () => {
        expanded = true;
        this.open();
        this.input?.focus();
      });

      this.querySelector("[data-promo-apply]")?.addEventListener("click", (e) => this.onSubmit(e));
      this.input?.addEventListener("keydown", (e) => {
        if (e.key === "Enter") this.onSubmit(e);
      });
      this.input?.addEventListener("input", () => {
        lastInput = this.input.value;
      });

      if (this.input) {
        let saved = null;
        try {
          saved = localStorage.getItem(KEY);
        } catch (e) {

        }
        const value = lastInput !== null ? lastInput : saved;
        if (value) this.input.value = value;
      }

      this.render();
      ensureSubscribed();
      if (!booted) {
        booted = true;
        if (this.dataset.hasGift === "true") revalidate(null, true);
        refreshGiftCards();
      }
    }

    disconnectedCallback() {
      live.delete(this);
    }

    open() {
      this.classList.add("is-open");
      this.querySelector("[data-promo-toggle]")?.setAttribute("aria-expanded", "true");
    }

    render() {
      if (!this.msg) return;
      const m = lastMsg;
      this.msg.textContent = m ? m.text : "";
      this.msg.hidden = !m;
      this.msg.classList.toggle("is-ok", Boolean(m && m.ok));

      if (this.hasAttribute("data-collapsible") && (expanded || (m && !m.ok))) this.open();
    }

    async onSubmit(e) {
      e.preventDefault();
      const code = String(this.input?.value || "").trim();
      lastInput = code;
      if (!code) return;
      const rule = findRule(code);
      if (rule) await applyGift(rule);
      else await applyCode(code);
    }
  }

  if (!customElements.get("promo-gift")) customElements.define("promo-gift", PromoGift);

  if (!window.__saDiscountRemove) {
    window.__saDiscountRemove = true;
    document.addEventListener("click", async (e) => {
      const gbtn = e.target.closest("[data-giftcard-remove]");
      if (gbtn) {
        e.preventDefault();
        if (gbtn.disabled) return;
        gbtn.disabled = true;
        try {
          await removeGiftCard(gbtn.dataset.giftcardRemove);
          say(null);
        } catch (err) {
          console.error("[promo-gift] скасування сертифіката", err);
          gbtn.disabled = false;
        }
        return;
      }
      const btn = e.target.closest("[data-discount-remove]");
      if (!btn || !window.CartAPI) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      const code = btn.dataset.discountRemove;
      lock += 1;
      try {
        const cart = await window.CartAPI.get();
        if (giftLines(cart).some((x) => same(x.it.properties[PROP], code))) {
          await dropGift(cart, code);
        } else {
          await window.CartAPI.update({ discount: codesWithout(cart, [code]).join(",") }, { source: SYNC });
        }
        try {
          if (same(localStorage.getItem(KEY), code)) localStorage.removeItem(KEY);
        } catch (err) {

        }
        say(null);
      } catch (err) {
        console.error("[promo-gift] скасування коду", err);
        btn.disabled = false;
      } finally {
        lock -= 1;
      }
    });
  }
})();
